import Cookies from '../vendor/js.cookie.js'

// Rest for success message
$('.js-close-announcement').on('click', function() {
    if (!Cookies.get('ClHideBanner')) {
        Cookies.set('ClHideBanner', 'true', {});
    }
    $('.info-banner').remove();
});

$(document).on("ready", function() {
    if (Cookies.get('ClHideBanner') == 'true') {
        $('.info-banner').remove();
    } else {
        $('.info-banner').addClass('animate');
    }
});